import React from 'react'
import classNames from 'classnames'

import { Icon } from '@app/components/util'

import { ICON_NAME } from '@app/constants/icon'

import styles from './styles.module.scss'

import type { LentaLogoProps } from './types'

export const LentaLogo: React.FC<LentaLogoProps> = ({ className: outerClassName, hideText }) => {
  const className = classNames(styles.lentaLogo, outerClassName)

  return (
    <div className={ className }>
      <Icon
        name={ ICON_NAME.lentaLogo }
        height='44px'
        width='38px'
      />
      { !hideText && (
        <p className={ styles.lentaLogo__text }>
          <Icon
            name={ ICON_NAME.lentaText }
            width='99px'
            height='19px'
          />
          <Icon
            name={ ICON_NAME.priceText }
            width='73px'
            height='10px'
          />
        </p>
      ) }
    </div>
  )
}
